import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Search, User, Phone, Mail, Building2 } from 'lucide-react'
import { useContacts } from '@/hooks/useContacts'

export default function DirekturiKontak() {
  const { contacts, loading } = useContacts()
  const navigate = useNavigate()
  const [query, setQuery] = useState('')

  const filtered = contacts.filter(c =>
    !query || [c.name, c.organization, c.position, c.email].some(v => v?.toLowerCase().includes(query.toLowerCase()))
  )

  return (
    <div className="p-6 max-w-5xl">
      <h1 className="text-xl font-bold text-gray-800 dark:text-white mb-1">Direktori Kontak</h1>
      <p className="text-sm text-gray-400 mb-5">Daftar kontak CERAH dan mitra organisasi</p>

      <div className="relative mb-5 max-w-sm">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          type="search"
          placeholder="Cari nama, jabatan, organisasi..."
          value={query}
          onChange={e => setQuery(e.target.value)}
          className="w-full pl-9 pr-4 py-2.5 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-cerah-teal/20 focus:border-cerah-teal"
        />
      </div>

      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {[...Array(8)].map((_, i) => <div key={i} className="h-24 bg-gray-100 dark:bg-gray-800 rounded-xl animate-pulse" />)}
        </div>
      ) : filtered.length === 0 ? (
        <div className="flex flex-col items-center py-16 text-center">
          <User size={36} className="text-gray-300 mb-3" />
          <p className="text-sm text-gray-500">{query ? 'Tidak ditemukan.' : 'Belum ada kontak.'}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {filtered.map(c => (
            <button
              key={c.id}
              onClick={() => navigate(`/app/direktori-kontak/${c.id}`)}
              className="text-left bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 p-4 flex items-start gap-3 hover:border-cerah-teal/30 hover:shadow-sm transition-all"
            >
              <div className="w-10 h-10 rounded-full bg-cerah-teal-light flex items-center justify-center shrink-0 text-cerah-teal font-bold text-sm">
                {c.photo_url
                  ? <img src={c.photo_url} alt={c.name} className="w-10 h-10 rounded-full object-cover" />
                  : c.name.slice(0, 2).toUpperCase()
                }
              </div>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-gray-800 dark:text-white">{c.name}</p>
                {c.position && <p className="text-xs text-gray-500 truncate">{c.position}</p>}
                <div className="flex items-center gap-3 mt-1.5 flex-wrap">
                  {c.organization && (
                    <span className="flex items-center gap-1 text-[10px] text-gray-400"><Building2 size={10} />{c.organization}</span>
                  )}
                  {c.phone && (
                    <span className="flex items-center gap-1 text-[10px] text-gray-400"><Phone size={10} />{c.phone}</span>
                  )}
                  {c.email && (
                    <span className="flex items-center gap-1 text-[10px] text-gray-400"><Mail size={10} />{c.email}</span>
                  )}
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
